export default __webpack_public_path__ + "static/media/schlock-vol-17-issue-6.09291a22.jpg";